import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/platform/components/primitives";

function LegalShell({ title, children }) {
  return (
    <div className="min-h-screen bg-[#151A24]">
      <header className="border-b border-[#242A38]">
        <div className="mx-auto flex h-16 max-w-3xl items-center px-6"><Logo /></div>
      </header>
      <main className="mx-auto max-w-3xl px-6 py-14">
        <h1 className="text-3xl font-semibold tracking-tight text-[#F4F5F8]">{title}</h1>
        <div className="mt-6 space-y-4 text-[15px] leading-relaxed text-[#AAB1BF]">{children}</div>
        <p className="mt-10 text-[13px] text-[#6E7686]">This is a placeholder document for the current build. <Link to="/signup" className="underline">Back to signup</Link>.</p>
      </main>
    </div>
  );
}

export function Terms() {
  return (
    <LegalShell title="Terms of Service">
      <p>These Terms of Service govern your use of Pinlayr. By creating an account you agree to use the product responsibly during your trial and any subsequent subscription.</p>
      <p>Full legal terms will be published before general availability.</p>
    </LegalShell>
  );
}

export function Privacy() {
  return (
    <LegalShell title="Privacy Policy">
      <p>We collect the minimum information required to operate your Pinlayr account: your name, email, and workspace details. We never sell your data.</p>
      <p>A complete privacy policy will be published before general availability.</p>
    </LegalShell>
  );
}
